import React from 'react';
import useErrorMessage from "./useErrorMessage";
import useLoading from "./useLoading";

export default function useAsyncErrorHandler() {
    const showErrorMessage = useErrorMessage();
    const setLoading = useLoading();

    return error => {
        const errorMessage = error.mensagem || error;

        showErrorMessage(errorMessage);

        if (error.detalhe) {
            console.log(error.detalhe);
        } else {
            console.log(errorMessage);
        }

        setLoading(false);
    };
}